<template>
  <table class="price-table uk-margin-remove-top uk-table uk-table-divider uk-table-justify">
    <thead>
      <tr>
        <th class="uk-table-shrink">
          {{$t('fields.organization')}}
        </th>
        <th class="uk-text-right uk-table-shrink">
          {{$t('fields.value')}}
        </th>
        <th>{{$t('fields.paymentFrequency')}}</th>
        <th v-if="showActions"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(price, index) in prices">
        <td v-if="price.organization">
          <router-link
            v-if="isAuthenticatedAsAdmin"
            :to="{ name: 'edit-organization', params: { id: price.organization.id } }"
          >
            {{price.organization.name}}
          </router-link>
          <span v-else>{{price.organization.name}}</span>
        </td>
        <td v-else class="uk-text-muted">
          <text-placeholder />
        </td>
        <td class="uk-text-right">
          <price :value="price.value" :was="price.type === 'WAS'" />
        </td>
        <td>
          {{$t(`paymentFrequencies.${price.paymentFrequency.toLowerCase()}`)}}
        </td>
        <td v-if="showActions">
          <data-grid-actions
            @edit="onEditItem(index)"
            @remove="onRemoveItem(index)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import UIkit from 'uikit';
import { mapGetters } from 'vuex';
import DataGridActions from '@/components/DataGridActions';
import Price from '@/components/Price';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'price-table',
  components: {
    DataGridActions,
    Price,
    TextPlaceholder,
  },
  props: {
    prices: {
      type: Array,
      required: true,
    },
    showActions: Boolean,
  },
  computed: mapGetters(['isAuthenticatedAsAdmin']),
  methods: {
    onEditItem(index) {
      this.$emit('edit', index);
    },
    onRemoveItem(index) {
      UIkit.modal
           .confirm(this.$t('confirmations.removePrice'))
           .then(() => { this.$emit('remove', index); })
           .catch(() => {});
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          removePrice: 'Den Preis wirklich entfernen?',
        },
        fields: {
          organization: 'VO',
          paymentFrequency: 'Zahlungsintervall',
          value: 'Preis',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// PriceTable.vue?099e7f64